//#region src/globalObject/globalObject.ts
const globalObject = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : void 0;
//#endregion
export { globalObject };

//# sourceMappingURL=globalObject.js.map